import {Route} from "@angular/router";
import {HomeComponent} from "./home/home.component";
import {RegisterComponent} from "./register/register.component";
import {LoginPageComponent} from "./login-page/login-page.component";
import {MainComponent} from "./main/main.component";
import {AuthGuard} from "./shared/security/auth-guard";
import {RestaurantCreateComponent} from "./restaurant/restaurant-create/restaurant-create.component";
import {RestaurantEditComponent} from "./restaurant/restaurant-edit/restaurant-edit.component";
import {RestaurantResolver} from "./shared/services/restaurant/restaurant-resolver";
import {TableResolver} from "./shared/services/table/table-resolver";
import {TableEditComponent} from "./table/table-edit/table-edit.component";
import {TableCreateComponent} from "./table/table-create/table-create.component";
import {TableCreateMultipleComponent} from "./table/table-create-multiple/table-create-multiple.component";
import {PrintQRCodesComponent} from "./table/print-qrcodes/print-qrcodes.component";
import {UserResolver} from "./shared/services/user/user-resolver";
import {UserEditComponent} from "./user/user-edit/user-edit.component";
import {UserSendCodeComponent} from "./user/user-send-code/user-send-code.component";
import {UserRegisterComponent} from "./user/user-register/user-register.component";
import {DownloadComponent} from "./download/download.component";
import {RestaurantSubscriptionComponent} from "./restaurant/restaurant-subscription/restaurant-subscription.component";
import {InvoiceHistoryComponent} from "./invoice/invoice-history/invoice-history.component";
import {CreditCardCreateComponent} from "./credit-card/credit-card-create/credit-card-create.component";
import {CreditCardEditComponent} from "./credit-card/credit-card-edit/credit-card-edit.component";
import {InvoiceDetailComponent} from "./invoice/invoice-detail/invoice-detail.component";
import {InvoiceResolver} from "./shared/services/stripe/invoice-resolver";
import {InvoiceEmailEditComponent} from "./invoice/invoice-email-edit/invoice-email-edit.component";
import {CustomerResolver} from "./shared/services/stripe/customer-resolver";
import {EmailUsComponent} from "./contact-us/email-us/email-us.component";
import {TablesRaitingsComponent} from "./table/tables-raitings/tables-raitings.component";


export const routerConfig : Route[] =  [

  {
    path:'Home',
    component : HomeComponent
  },
  {
    path:'download',
    component: DownloadComponent
  },
  {
    path:'main',
    component: MainComponent,
  },
  {
    canActivate:[AuthGuard],
    path: 'restaurants',
    children:[
      {
        path: '',
        component: MainComponent
      },
      {
        path: 'create',
        component: RestaurantCreateComponent
      },
      {
        path: ':id',
        canActivate:[AuthGuard],
        children:[
          {
            path:'',
            component: MainComponent,//RestaurantDetailComponent
            resolve: {
              restaurant: RestaurantResolver
            }
          },
          {
            path: 'detail',
            component: MainComponent//RestaurantDetailComponent
          },
          {
            path: 'edit',
            component: RestaurantEditComponent,
            resolve: {
              restaurant: RestaurantResolver
            }
          },
          {
            path: 'subs',
            component: RestaurantSubscriptionComponent,
            resolve: {
              restaurant: RestaurantResolver
            }
          },
          {
            path: 'invHist',
            component: InvoiceHistoryComponent,
            resolve: {
              restaurant: RestaurantResolver
            }
          },
          {
            path:'addCC',
            component: CreditCardCreateComponent,
            resolve: {
              restaurant: RestaurantResolver
            }
          },
          {
            path:'editCC',
            component: CreditCardEditComponent,
            resolve: {
              restaurant: RestaurantResolver
            }
          },
          {
            path:'emailUs',
            component:EmailUsComponent,
            resolve:{
              restaurant: RestaurantResolver
            }
          },
          {
            path:'invDetail/:inv',
            component: InvoiceDetailComponent,
            resolve:{
              invoice : InvoiceResolver
            }
          },
          {
            path:'editInvEml/:cust',
            component:InvoiceEmailEditComponent,
            resolve:{
              customer: CustomerResolver
            }
          },
        ]
      },
    ]
  },
  {
    canActivate:[AuthGuard],
    path: 'tables',
    children:[
      {
        path: '',
        component: MainComponent
      },
      {
        path:'PrintQRCodes/:id',
        component : PrintQRCodesComponent,
        resolve : {
          restaurant: RestaurantResolver
        }
      },
      {
        path:'TablesRatings/:id',
        component : TablesRaitingsComponent,
        resolve : {
          restaurant: RestaurantResolver
        }
      },
      {
        path: 'createMultiple/:id',
        component: TableCreateMultipleComponent,
        resolve: {
          restaurant: RestaurantResolver
        }
      },
      {
        path: 'create/:id',
        component: TableCreateComponent,
        resolve: {
          restaurant: RestaurantResolver
        }
      },
      {
        path: ':id',
        canActivate:[AuthGuard],
        children:[
          {
            path: 'detail',
            component: MainComponent//RestaurantDetailComponent
          },
          {
            path: 'edit',
            component: TableEditComponent,
            resolve: {
              table: TableResolver
            }
          }
        ]
      }
    ]
  },
  {
    canActivate:[AuthGuard],
    path: 'users',
    children:[
      {
        path: '',
        component: MainComponent
      },
      {
        path: 'create/:id',
        component: UserSendCodeComponent,
        resolve: {
          restaurant: RestaurantResolver
          },
        },
      {
        path: 'edit/:id/:XR',
        component: UserEditComponent,
        resolve: {
          user: UserResolver
        }
      },
      {
        path:'download',
        component: DownloadComponent
      },


    ]
  },
  {
    path: 'reguser',
    children:[
      {
        path: 'register/:code/:id',
        component: UserRegisterComponent
      },
    ]
  },
  {
    path:'login',
    component:LoginPageComponent,
  },
  {
    path:'register',
    component: RegisterComponent
  },
  {
    path:'', redirectTo: '/Home',  pathMatch: 'full'
  },
  {
    path:'**', redirectTo: '/Home',  pathMatch: 'full'
  }

];



// WEBPACK FOOTER //
// ./src/app/router.config.ts